module.exports = __webpack_public_path__ + "img/cufang.72087e29.png";